<template>
  <dn-component
    v-detect-position="detectPositionPayload"
    :type="adComponent"
    :data="getData(ad)"
    :class="{[ad.class || '']: !isPreview}"
  />
</template>

<script lang="ts" setup>
const props = defineProps({
  ad: {
    type: Object,
    required: true,
    validator: (value: any) => {
      return !!value;
    }
  }
});

const isPreview = inject<Ref<boolean>>('isPreview', ref(false));

const detectPositionPayload = computed(() => {
  return !isPreview.value && props.ad.detectPosition
    ? { type: 'liveWrappedAd', key: props.ad.id, action: [props.ad.collisionAction || 'sticky-hide'] }
    : null;
});

const mapping: Record<string, string> = {
  ad: 'liveWrappedAd',
  ad_group: 'adGroup',
  job: 'jobCollection',
  readpeak: 'readPeakAd',
  ukens_stilling: 'ukensStillingAd'
};

const adComponent = computed(() => {
  const adType = props.ad.type || 'ad';
  if (isPreview.value) {
    return adType === 'ad_group' ? 'adGroupPreview' : 'adPreview';
  }
  const mappedType = mapping[adType];
  return mappedType || adType;
});

const getData = (ad: { type: Object; }) => {
  if (ad.type === 'embed') {
    const content = ad.content[getDeviceType()] || '';
    return { ...ad, content };
  }
  return { ...ad, minHeight: getAdMinHeight(ad) };
};
</script>
